import { useState } from 'react';
import { supabase } from './supabase';
import { useEffectiveUser } from './ImpersonationContext';
import { buyToken, sellTokenPercent } from './bot/jupiterSwap';
import { botEngine } from './bot/botEngine';

export function useManualTrade(keypair, vpsWalletId = null) {
  const { isImpersonating } = useEffectiveUser();
  const [buyLoading,setBuyLoading]=useState(false);
  const [sellLoading,setSellLoading]=useState(false);
  const [msg,setMsg]=useState(null);
  const showMsg=(text,type='ok')=>{ setMsg({text,type}); setTimeout(()=>setMsg(null),6000); };

  const executeBuy=async(tokenMint,amountSol,slippage='auto',jitoTip='low')=>{
    if (isImpersonating) return showMsg('Action désactivée — mode lecture seule','err');
    if(!keypair && !vpsWalletId && keypair !== 'sim') return showMsg('Wallet bot non accessible','err');
    if(!tokenMint) return showMsg('Aucun token sélectionné','err');
    const amt=parseFloat(amountSol);
    if(!amt||amt<=0) return showMsg('Montant invalide','err');
    setBuyLoading(true);
    try {
      if(keypair === 'sim') {
        const result = await botEngine.executSimBuy(tokenMint, amt);
        showMsg(`Sim achat ${amt} SOL — ${result.tokenAmount.toFixed(0)} tokens`);
      } else if(vpsWalletId) {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.user) throw new Error('Non connecté');
        const slippageBps = slippage === 'auto' ? 150 : Math.max(parseInt(slippage)*100, 50);
        const r = await fetch('https://copyccxx.com/api/wallet/buy', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId: session.user.id, walletId: vpsWalletId, tokenMint, amountSol: amt, slippageBps, jitoTip }),
        });
        const j = await r.json();
        if (!j.success) throw new Error(j.error || 'Erreur achat VPS');
        showMsg(`Achat envoyé ! TX: ${j.signature.slice(0,12)}...`);
      } else {
        const slippageBps=slippage==='auto'?50:parseInt(slippage)*100;
        const result=await buyToken({keypair,tokenMint,amountSol:amt,slippageBps,jitoTip});
        showMsg(`Achat envoyé ! TX: ${result.signature.slice(0,12)}...`);
      }
    } catch(e){ showMsg(e.message,'err'); }
    setBuyLoading(false);
  };

  const executeSell=async(tokenMint,pct,slippage='auto',jitoTip='low')=>{
    if (isImpersonating) return showMsg('Action désactivée — mode lecture seule','err');
    if(!keypair && !vpsWalletId && keypair !== 'sim') return showMsg('Wallet bot non accessible','err');
    if(!tokenMint) return showMsg('Aucun token sélectionné','err');
    setSellLoading(true);
    try {
      if(keypair === 'sim') {
        const pctNum = parseInt(pct) || 100;
        const result = await botEngine.executSimSell(tokenMint, pctNum, vpsWalletId || 'sim');
        showMsg(`Sim vente ${pct} — PNL: ${result.pnlUsd>=0?'+':''}${result.pnlUsd.toFixed(2)}$`);
      } else if(vpsWalletId) {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.user) throw new Error('Non connecté');
        const slippageBps = slippage === 'auto' ? 150 : Math.max(parseInt(slippage)*100, 100);
        const r = await fetch('https://copyccxx.com/api/wallet/sell', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId: session.user.id, walletId: vpsWalletId, tokenMint, percentToSell: parseInt(pct)||100, slippageBps }),
        });
        const j = await r.json();
        if (!j.success) throw new Error(j.error || 'Erreur vente VPS');
        showMsg(`Vente ${pct} envoyée ! TX: ${j.signature.slice(0,12)}...`);
      } else {
        const slippageBps=slippage==='auto'?100:parseInt(slippage)*100;
        const result=await sellTokenPercent({keypair,tokenMint,percentToSell:parseInt(pct)||100,slippageBps,jitoTip});
        showMsg(`Vente ${pct} envoyée ! TX: ${result.signature.slice(0,12)}...`);
      }
    } catch(e){ showMsg(e.message,'err'); }
    setSellLoading(false);
  };

  return {buyLoading,sellLoading,msg,executeBuy,executeSell};
}

export function TxMsg({msg}) {
  if(!msg) return null;
  return (
    <div style={{padding:'7px 10px',borderRadius:6,background:msg.type==='ok'?'rgba(0,229,204,0.08)':'rgba(255,107,107,0.08)',border:`1px solid ${msg.type==='ok'?'#00e5cc33':'#ff6b6b33'}`,fontSize:10,color:msg.type==='ok'?'#00e5cc':'#ff6b6b',lineHeight:1.5,wordBreak:'break-all'}}>
      {msg.text}
    </div>
  );
}
